import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import CreateClassifiedListingForm from "../components/CarsBikesBusCustomFiledForm/CreateClassifiedListingForm"
import Container from "../components/layout/Container";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const CreateClassifiedAdListingForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"CREATING AUCTION LISTING"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <CreateClassifiedListingForm/>
        </div>
      </div>
    </Container>
  );
};

export default CreateClassifiedAdListingForm;
